var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgImgrecommend1 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 285,
  height: 140,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#img_recommend1_svg__a)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 162,
  height: 101,
  x: 54,
  y: 9,
  fill: "#fff",
  rx: 4
}), /*#__PURE__*/React.createElement("rect", {
  width: 68.5,
  height: 5.708,
  x: 121.681,
  y: 21.883,
  fill: "#F0F0F0",
  rx: 2.854
}), /*#__PURE__*/React.createElement("rect", {
  width: 88,
  height: 6,
  x: 66,
  y: 75,
  fill: "#F0F0F0",
  rx: 3
}), /*#__PURE__*/React.createElement("rect", {
  width: 56,
  height: 6,
  x: 66,
  y: 86,
  fill: "#F0F0F0",
  rx: 3
}), /*#__PURE__*/React.createElement("rect", {
  width: 61,
  height: 6,
  x: 66,
  y: 97,
  fill: "#F0F0F0",
  rx: 3
}), /*#__PURE__*/React.createElement("rect", {
  width: 59.938,
  height: 3.806,
  x: 121.681,
  y: 33.299,
  fill: "#F0F0F0",
  rx: 1.903
}), /*#__PURE__*/React.createElement("rect", {
  width: 74.208,
  height: 3.806,
  x: 121.681,
  y: 39.959,
  fill: "#F0F0F0",
  rx: 1.903
}), /*#__PURE__*/React.createElement("rect", {
  width: 79.917,
  height: 19.979,
  x: 121.681,
  y: 49.473,
  fill: "#E8E9EB",
  rx: 4
}), /*#__PURE__*/React.createElement("path", {
  fill: "#BBBFC3",
  d: "m166.516 57.354-.598 2.941a1.03 1.03 0 0 1-.404.621 1.26 1.26 0 0 1-.753.245h-5.688l.216 1.056h5.271c.233 0 .46.062.654.177.193.116.344.281.433.474a.96.96 0 0 1 .067.61 1.03 1.03 0 0 1-.322.54 1.2 1.2 0 0 1-.603.289c-.228.04-.464.02-.68-.06a1.16 1.16 0 0 1-.528-.389.98.98 0 0 1-.198-.586.9.9 0 0 1 .069-.352h-2.883a.967.967 0 0 1-.064.84c-.088.152-.215.282-.371.38a1.3 1.3 0 0 1-.523.18c-.189.022-.38.003-.558-.056a1.2 1.2 0 0 1-.465-.283 1 1 0 0 1-.266-.443.95.95 0 0 1-.007-.503c.043-.166.13-.32.253-.45l-1.358-6.7h-.887a.41.41 0 0 1-.277-.103.33.33 0 0 1-.115-.249c0-.093.041-.182.115-.248a.41.41 0 0 1 .277-.103h.887a.84.84 0 0 1 .501.163.7.7 0 0 1 .269.413l.24 1.182h7.909q.087 0 .165.034a.38.38 0 0 1 .215.228q.023.075.007.152"
}), /*#__PURE__*/React.createElement("rect", {
  width: 50.672,
  height: 46.618,
  x: 65.549,
  y: 21.883,
  fill: "#F0F0F0",
  rx: 1
}), /*#__PURE__*/React.createElement("path", {
  fill: "#939393",
  d: "M97.433 50.993c-5.148-3.003-5.907-4.161-9.027-10.655l-.115-.24C84.987 33.223 83.754 32 81.377 32c-2.599 0-4.239 5.386-2.9 8.997 1.286 3.462 1.528 5.715 1.528 14.678l1.061.23 1.707-.315s-.37-5.227.572-7.696c.606 1.007 1.416 2.437 2.467 4.454C88.46 57.42 91.025 58 93.575 58h9.427c.498-.105.998-.443.998-1.773 0-1.183-2.22-2.698-6.567-5.234M81.408 32.8c1.54.008 2.738.561 6.14 7.638l.116.24c2.865 5.965 3.736 7.776 8.05 10.282-.925.072-2.64.727-2.64.727-3.624-2.54-6.304-7.606-7.81-10.843-.478-1.028-.892-1.915-1.25-2.512-.857-1.427-2.019-1.928-3.176-2.072-.41-1.117-.514-2.475-.146-3.076.08-.13.24-.31.716-.384m.523 18.562a37 37 0 0 0-.014 3.572l-.88.145.014-5.838c.094-1.877.312-3.454.777-3.593 0 0 .295.303 1.003 1.413-.493.905-.786 2.317-.9 4.3m.332-11.315a93 93 0 0 1-1.229-2.924c.93.115 1.696.653 2.272 1.613.336.56.742 1.431 1.21 2.439 1.529 3.283 3.824 8.2 7.563 10.882-3.87.981-5.442-1.958-9.815-12.01"
}), /*#__PURE__*/React.createElement("g", {
  filter: "url(#img_recommend1_svg__b)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 109.511,
  height: 56,
  x: 142,
  y: 75,
  fill: "#C2E0D9",
  rx: 2
})), /*#__PURE__*/React.createElement("rect", {
  width: 25.771,
  height: 23.709,
  x: 150.246,
  y: 80.758,
  fill: "#008060",
  rx: 1
}), /*#__PURE__*/React.createElement("rect", {
  width: 25.771,
  height: 23.709,
  x: 183.067,
  y: 81.228,
  fill: "#008060",
  rx: 1
}), /*#__PURE__*/React.createElement("rect", {
  width: 25.771,
  height: 23.709,
  x: 216.666,
  y: 81.228,
  fill: "#008060",
  rx: 1
}), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#img_recommend1_svg__c)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#94C3B8",
  d: "M152.398 108.604c-.93 0-1.687.756-1.687 1.686s.757 1.687 1.687 1.687 1.686-.757 1.686-1.687-.756-1.686-1.686-1.686"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FAFAFA",
  d: "m153.253 109.933-.914.914a.14.14 0 0 1-.198 0l-.457-.457a.14.14 0 1 1 .199-.199l.357.358.814-.814a.14.14 0 0 1 .199.198"
})), /*#__PURE__*/React.createElement("rect", {
  width: 57.912,
  height: 3.373,
  x: 156.333,
  y: 108.604,
  fill: "#94C3B8",
  rx: 1.687
}), /*#__PURE__*/React.createElement("rect", {
  width: 27.55,
  height: 3.373,
  x: 216.494,
  y: 108.604,
  fill: "#94C3B8",
  rx: 1.687
}), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#img_recommend1_svg__d)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#94C3B8",
  d: "M152.398 114.822a1.69 1.69 0 0 0-1.687 1.687c0 .93.757 1.687 1.687 1.687a1.69 1.69 0 0 0 1.687-1.687 1.69 1.69 0 0 0-1.687-1.687"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FAFAFA",
  d: "m153.253 116.152-.913.914a.14.14 0 0 1-.199 0l-.457-.457a.14.14 0 1 1 .199-.199l.357.358.815-.815a.14.14 0 0 1 .198.199"
})), /*#__PURE__*/React.createElement("rect", {
  width: 57.912,
  height: 3.373,
  x: 156.333,
  y: 114.822,
  fill: "#94C3B8",
  rx: 1.687
}), /*#__PURE__*/React.createElement("rect", {
  width: 27.55,
  height: 3.373,
  x: 216.494,
  y: 114.822,
  fill: "#94C3B8",
  rx: 1.687
}), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#img_recommend1_svg__e)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#94C3B8",
  d: "M152.398 121.047a1.69 1.69 0 0 0-1.687 1.687c0 .93.757 1.686 1.687 1.686s1.687-.756 1.687-1.686a1.69 1.69 0 0 0-1.687-1.687"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FAFAFA",
  d: "m153.253 122.377-.913.913a.14.14 0 0 1-.1.042.14.14 0 0 1-.099-.042l-.457-.456a.14.14 0 1 1 .199-.199l.357.357.815-.814a.14.14 0 0 1 .198.199"
})), /*#__PURE__*/React.createElement("rect", {
  width: 57.912,
  height: 3.373,
  x: 156.333,
  y: 121.047,
  fill: "#94C3B8",
  rx: 1.687
}), /*#__PURE__*/React.createElement("rect", {
  width: 27.55,
  height: 3.373,
  x: 216.494,
  y: 121.047,
  fill: "#94C3B8",
  rx: 1.687
}), /*#__PURE__*/React.createElement("path", {
  fill: "#008060",
  d: "M181.821 93.49h-1.383v1.421h-.967v-1.42h-1.383v-.893h1.383v-1.42h.967v1.42h1.383zM214.178 93.49h-1.384v1.421h-.966v-1.42h-1.384v-.893h1.384v-1.42h.966v1.42h1.384z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#BABEC3",
  d: "M242 26.5a1.5 1.5 0 1 0 2.998.002A1.5 1.5 0 0 0 242 26.5M75.25 121.8c.248 0 .451.222.451.494v2.172c0 .271-.203.493-.452.493s-.452-.222-.452-.493v-2.172c0-.272.203-.494.452-.494M75.25 118c.248 0 .451.221.451.493v2.172c0 .272-.203.493-.452.493s-.452-.221-.452-.493v-2.172c0-.272.203-.493.452-.493M72.452 120.986h1.788c.249 0 .452.222.452.493 0 .272-.203.494-.452.494h-1.788c-.249 0-.452-.222-.452-.494 0-.271.203-.493.452-.493M76.258 120.986h1.788c.249 0 .452.222.452.493 0 .272-.203.494-.452.494h-1.788c-.249 0-.452-.222-.452-.494 0-.271.203-.493.452-.493M34.25 32.8c.248 0 .451.222.451.494v2.172c0 .271-.203.493-.452.493s-.452-.222-.452-.493v-2.172c0-.272.203-.494.452-.494M34.25 29c.248 0 .451.221.451.493v2.172c0 .271-.203.493-.452.493s-.452-.222-.452-.493v-2.172c0-.272.203-.493.452-.493M31.452 31.986h1.788c.249 0 .452.222.452.494 0 .271-.203.493-.452.493h-1.788c-.249 0-.452-.222-.452-.493 0-.272.203-.494.452-.494M35.258 31.986h1.788c.249 0 .452.222.452.494 0 .271-.203.493-.452.493h-1.788c-.249 0-.452-.222-.452-.493 0-.272.203-.494.452-.494"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#008060",
  d: "m212.283 42.437.088.745zm10.658 6.154-.689-.297zm-72.208-32.927a.75.75 0 1 1-.592-1.378zm71.611 50.786c.134-.365.248-.91.32-1.622l1.493.153c-.079.77-.209 1.455-.405 1.986zm.362-5.2a38 38 0 0 0-.379-3.608l1.483-.226c.199 1.306.329 2.575.394 3.752zm-1.09-7.167a32 32 0 0 0-1.067-3.45l1.403-.529c.44 1.165.811 2.386 1.119 3.615zm-2.588-6.677c-.639-1.082-1.356-2.001-2.147-2.705l.997-1.12c.935.831 1.745 1.883 2.442 3.061zm-5.034-4.183a5.5 5.5 0 0 0-1.623-.041l-.176-1.49a7 7 0 0 1 2.065.055zm-1.623-.041c-.539.063-.731.258-.816.42l-1.329-.695c.373-.713 1.078-1.11 1.969-1.215zm-.276 2.908c.451.83 1.112 1.708 1.9 2.497l-1.061 1.06c-.878-.879-1.629-1.87-2.157-2.84zm4.393 4.37c.984.51 1.94.737 2.786.62l.205 1.486c-1.254.173-2.528-.177-3.682-.775zm5.027-.841a7 7 0 0 0 .737-1.325l1.378.593a8.4 8.4 0 0 1-.901 1.613zm.737-1.325q.344-.801.402-1.683l1.497.1a6.6 6.6 0 0 1-.521 2.176zm-.311-5.222c-.449-1.048-1.1-2.148-1.941-3.284l1.205-.892c.894 1.207 1.61 2.407 2.115 3.585zm-4.463-6.226a44 44 0 0 0-2.858-2.687l.981-1.135a46 46 0 0 1 2.955 2.778zm-5.93-5.162a73 73 0 0 0-3.223-2.294l.838-1.244a76 76 0 0 1 3.289 2.34zm-6.551-4.424a96 96 0 0 0-3.427-1.989l.727-1.312a98 98 0 0 1 3.48 2.02zm-6.934-3.841a107 107 0 0 0-3.573-1.719l.625-1.363q1.84.842 3.623 1.742zm-7.205-3.303q-1.832-.758-3.69-1.448l.521-1.406q1.887.699 3.743 1.468zm-7.432-2.752a93 93 0 0 0-3.789-1.147l.404-1.445q1.926.539 3.85 1.166zm-7.619-2.123a74 74 0 0 0-3.879-.784l.257-1.477q1.965.341 3.957.8zM168.02 13.9a53 53 0 0 0-3.92-.292l.055-1.499q1.982.073 4.03.3zm-7.843-.262q-2.012.109-3.883.428l-.253-1.478a36 36 0 0 1 4.054-.448zm-7.645 1.35q-.927.303-1.799.677l-.592-1.378a23 23 0 0 1 1.924-.725z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "img_recommend1_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h285v140H0z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "img_recommend1_svg__c"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M150.711 108.604h3.373v3.373h-3.373z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "img_recommend1_svg__d"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M150.711 114.822h3.373v3.373h-3.373z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "img_recommend1_svg__e"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M150.711 121.047h3.373v3.373h-3.373z"
})), /*#__PURE__*/React.createElement("filter", {
  id: "img_recommend1_svg__b",
  width: 121.511,
  height: 68,
  x: 136,
  y: 69,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 3
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_9997_2012"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_9997_2012",
  result: "shape"
})))));
export { SvgImgrecommend1 as ReactComponent };
export default __webpack_public_path__ + "static/media/img.recommend1.313e8685.svg";